<template>
  <div id="app">
    <KlimaProductsComponent />
  </div>
</template>

<script>
import KlimaProductsComponent from "@/pages/KlimaProducts/KlimaProductsComponent";

export default {
  name: 'App',
  components: {
    KlimaProductsComponent,
  }
}
</script>
